import "bootstrap";
import axios from "axios";
import * as autosize from "autosize";
import moment from "moment";

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueClipboard from "vue-clipboard2";
import VTooltip from "v-tooltip";
import Cleave from "cleave.js";
import VueTour from "vue-tour";
import VCalendar from "v-calendar";
require("vue-tour/dist/vue-tour.css");

Vue.config.productionTip = false;
let env = process.env.VUE_APP_ENV != "local" ? "" : "local.";
Vue.use(VueClipboard);
Vue.use(VueTour);
Vue.use(VCalendar);
Vue.use(VTooltip, {
  defaultTrigger: window.innerWidth > 768 ? "hover focus click" : "click",
});

axios.get(`/config/config.${env}json`).then(function (res) {
  if (res.status == 200) {
    let config = res.data;
    localStorage.setItem("config", JSON.stringify(config));

    let httpClient = axios.create({
      baseURL: config.api + `/api/`,
      headers: store.getters.headers,
    });

    httpClient.interceptors.response.use(
      (res) => {
        return res;
      },
      (error) => {
        if (error) {
          if (error.response) {
            if (
              (error.response.data.error || {}).message == "Unauthenticated." ||
              (error.response.data.error || {}).message == "token expired"
            ) {
              if (window.location.path != "/login") {
                router.push({ path: "/logout" });
              }
              return Promise.reject();
            }

            if (error.response.status !== 401) {
              return Promise.reject(error.response);
            } else {
              router.push({ path: "/logout" });
            }
          } else {
            return Promise.reject(error);
          }
        }
      }
    );
    Vue.prototype.$http = httpClient;
    store.$http = httpClient;

    //Global Components
    const files = require.context("./components/global/", true, /\.vue$/i);
    files.keys().map((key) => {
      Vue.component(key.split("/").pop().split(".")[0], files(key).default);
    });

    //Directives
    Vue.directive("autosize", {
      bind: (el) => {
        setTimeout(function () {
          autosize(el);
        }, 50);
      },
    });

    //filters
    Vue.filter("fullDate", (value) => {
      if (value) {
        return moment(value).format("LLL");
      }
      return value;
    });

    Vue.filter("nl2br", (value) => {
      if (value) {
        let result = value.split(/\\r?\\n/).join("<br>");
        result = result.split(/\r?\n/).join("<br>");
        return result;
      }
      return value;
    });

    Vue.directive("cleave", {
      inserted: (el, binding) => {
        if (binding.value) {
          el.cleave = new Cleave(el, binding.value || {});
        }
      },
      update: (el) => {
        if (typeof el.cleave !== "undefined") {
          const event = new Event("input", { bubbles: true });
          setTimeout(function () {
            el.value = el.cleave.properties.result;
            el.dispatchEvent(event);
          }, 100);
        }
      },
    });
    Vue.directive("click-outside", {
      bind: (el, binding) => {
        el.clickOutsideEvent = (event) => {
          if (!(el == event.target || el.contains(event.target))) {
            binding.value();
          }
        };
        document.addEventListener("click", el.clickOutsideEvent);
      },
      unbind: (el) => {
        document.removeEventListener("click", el.clickOutsideEvent);
      },
    });
    //Bootstrap Vue
    new Vue({
      router,
      store,
      render: (h) => h(App),
    }).$mount("#app");
  }
});
